<template>
<div >
    <v-toolbar flat color="white">
        <v-btn color="primary" dark class="mb-2" @click="newDialog=true; cancelFields()" round >ADD ACCESS POINT</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

     <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">

        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD ACCESS POINT</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.description"
                    label="Description"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

               </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveNew">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Edit Modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-card>
       
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT ACCESS POINT</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
            
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.description"
                    label="Description"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
     
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save" >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="accessPoints"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props" >
        <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="text-xs-center">{{props.item.description}}</td>      
    
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
    
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
export default {
  props:["accesspointscomponent",
          "accessPointGroupId" ],
  data() {
    return {
    showDetails: true,
    isloading:true,
    loading: false, 
    expand: false,
    search: "",
    dialog: false,
    newDialog: false,
    pagination: { },
    headers: [
            {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Description",
        align: "center",
        value: "description"
      }
    ],
    accessPoints: [],
    editedIndex: -1,
    editedItem: {
        name: "",
        description: "",
        isDeleted: false
    },
    defaultItem: {
        name: "",
        description: "",
        isDeleted: false
    },
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
      search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.accessPoints= await this.searchAccessPoints(value)
      }
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
  },
  created() {
    this.initialize();
  },
  methods: {
     cancelFields(){
    this.editedItem.name="",
    this.editedItem.description=""      
    },
     searchAccessPoints(search){
        if(typeof(this.accessPointGroupId)!= 'undefined' && this.accessPointGroupId != null) {
        
      if(search.search!==""){  
        this.isloading =true
          Api()
       .get("/accessPointAccessPointGroups/getAccessPoints/" + this.$route.params.accessPointGroupId,{
          params: {
          search: search.search,
         }
          })         
        .then(response => {       
           this.accessPoints = [];
           for(let i=0; i< response.data.length; i++)
                 {
                   this.accessPoints.push(response.data[i].accessPoint)
                 }
             this.isloading =false
        });
        }
        } else {
          if(search.search!==""){      
        Api()
        .get('/accessPoints/getall',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.accessPoints=response.data
          this.isloading =false
        })} 
        }     
    },
    initialize() {
      this.fetchAccessPoints();
    },
       fetchAccessPoints() {
        this.isloading =true
     
        if(typeof(this.accessPointGroupId)!= 'undefined' && this.accessPointGroupId != null) {
           Api()
          .get("/accessPointAccessPointGroups/getAccessPoints/" + this.$route.params.accessPointGroupId)  
        .then(response => {       
           this.accessPoints = [];
           for(let i=0; i< response.data.length; i++)
                 {
                   this.accessPoints.push(response.data[i].accessPoint)
                 }
             this.isloading =false
        });
        
        } else {    
        Api()
        .get('/accessPoints/getall')
        .then(response=>{
          this.accessPoints=response.data
          this.isloading =false
        })} 
    },
    editItem(item) {
      this.editedIndex = this.accessPoints.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
      deleteItem(id) {
       let accessPointGroupTempId = this.$route.params.accessPointGroupId
       let tempAccessPId = id
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/accessPoints/" + id, {
          isDeleted: true
        }).then(response => {
               if(typeof(accessPointGroupTempId) != 'undefined'){
           Api().get('/accessPointAccessPointGroups/getBothAccessPointAndGroup/' + accessPointGroupTempId + '/' + id)
            .then(response=> {
                Api().put("/accessPointAccessPointGroups/" + response.data[0].id, {
              isDeleted: true
             })
                 this.fetchAccessPoints();
             })
      }else{
            this.fetchAccessPoints();
      }
        })
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
       let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please enter a name.");
      }
      if (proceed == true) {
        Api().put("/accessPoints/" + this.editedItem.id, {
          name: this.editedItem.name,
          description: this.editedItem.description,          
          isDeleted: this.editedItem.isDeleted
        }).then(response => {
            this.fetchAccessPoints();
        })
        this.close();
      }
      },
      saveNew() {
      let accessPointGroupTempId = this.$route.params.accessPointGroupId
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please enter a name.");
      }
      if (proceed == true) {
        Api().post("/accessPoints", {
          name: this.editedItem.name,
          description: this.editedItem.description,          
          isDeleted: this.editedItem.isDeleted  
        }).then(response => {
            let tempAccessPId = response.data.id
          if(typeof(accessPointGroupTempId) != 'undefined'){
             Api().post("/accessPointAccessPointGroups", {
                   accessPointGroupId: accessPointGroupTempId,
                   accessPointId: tempAccessPId
        })
          }
            this.fetchAccessPoints();
        })
        this.close();
    }
  }
  }
};
</script>